import { Icons } from '@/icons/icons'
import { DocumentPreview } from '../Preview/types/PreviewTypes'

export const isTransformableToPdf = (file: any) => {
  return process.env.VUE_APP_SYNCFUSION_PDF_CONVERT_VALID_EXTENSIONS.includes(file.type.toString().toLowerCase())
}

// TODO - no se usa estaba en el filemanager
export const isMSOfficeFile = (file: any) => {
  const msOfficeExtensions = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx']
  return msOfficeExtensions.includes(file.type)
}

export const isDocsIAFile = (fileType: string) => {
  const docsIAExtensions = ['.pdf', '.doc', '.docx', '.rtf', '.odt', '.jpg', '.jpeg', '.png', '.txt', '.eml', '.msg']
  return docsIAExtensions.includes(fileType)
}

export const checkIfTablet = () => {
  return /Android|webOS|iPhone|Mac|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const isNeedRefreshToken = (dateTime: number): boolean => {
  const HOUR = 1000 * 55 * 60
  const anHourAgo = Date.now() - HOUR
  return dateTime < anHourAgo
}

export const createPreviewButtonOnDetailsViewTable = (detailsViewElement: any, documentPreview: DocumentPreview) => {
  const elem = detailsViewElement.querySelector('.e-fe-grid-icon .e-fe-icon')
  if (elem) {
    const buttonPreview = document.createElement('span')
    buttonPreview.id = `preview-item-${documentPreview.id}`
    buttonPreview.classList.add('e-fe-icon')
    buttonPreview.classList.add(Icons.VISIBLE)
    buttonPreview.classList.add('icon-preview')
    // buttonPreview.style.cursor = 'pointer'
    buttonPreview.style.paddingLeft = '5px'
    // buttonPreview.addEventListener('click', this.previewAction);
    ;(buttonPreview as any).documentPreview = JSON.stringify({
      id: documentPreview.id,
      type: documentPreview.type
    })
    elem.parentNode.appendChild(buttonPreview)
  }
}
